import {
    Component,
    ElementRef,
    HostBinding,
    OnInit,
    ViewEncapsulation,
    inject,
    input,
    ChangeDetectionStrategy,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --height: initial; --padding-start: 0; --padding-end: 0; --padding-top: 0; --padding-bottom: 0; --margin-start: 0; --margin-end: 0; --margin-top: 0; --margin-bottom: 0; --border-radius: initial; --border-width: initial; --border-style: initial; --border-color: initial; --background: initial; --box-shadow: none; --gap: var(--bazis-margin-3x); display: flex; gap: var(--gap); justify-content: space-between; align-items: center; height: var(--height); padding-left: var(--padding-start); padding-right: var(--padding-end); padding-top: var(--padding-top); padding-bottom: var(--padding-bottom); margin-left: var(--margin-start); margin-right: var(--margin-end); margin-top: var(--margin-top); margin-bottom: var(--margin-bottom); border-radius: var(--border-radius); border-width: var(--border-width); border-style: var(--border-style); border-color: var(--border-color); background: var(--background); box-shadow: var(--box-shadow); } :host(.bazis-toolbar_vertical) { flex-direction: column; } :host(.bazis-toolbar_outline) { --border-width: 1px 0 1px 0; --border-style: solid; --border-color: var(--bazis-border-color); --padding-top: var(--bazis-padding-3x); --padding-bottom: var(--bazis-padding-3x); } :host(.bazis-toolbar_vertical.bazis-toolbar_outline) { --border-width: 0 1px 0 1px; --padding-start: var(--bazis-padding-3x); --padding-end: var(--bazis-padding-3x); --padding-top: 0; --padding-bottom: 0; } :host(.bazis-toolbar_top) { align-items: flex-start; } :host(.bazis-toolbar_bottom) { align-items: flex-end; } :host(.bazis-toolbar_baseline) { align-items: baseline; } ::slotted(*) { display: flex; } @media screen and (max-width: 576px) { :host(.bazis-toolbar_wrap) { flex-wrap: wrap; } :host(.bazis-toolbar_wrap) > [part] { width: 100%; } } @media screen and (max-width: 576px) { :host(.bazis-toolbar_column) { flex-direction: column; } :host(.bazis-toolbar_column) > [part] { width: 100%; } :host(.bazis-toolbar_column) .bh-line-elements { flex-direction: column; } :host(.bazis-toolbar_column) .bh-line-elements bazis-button { display: block; } } @media screen and (max-width: 576px) { :host(.bazis-toolbar_column-reverse) { flex-direction: column-reverse; } :host(.bazis-toolbar_column-reverse) > [part] { width: 100%; } :host(.bazis-toolbar_column-reverse) .bh-line-elements { flex-direction: column; } :host(.bazis-toolbar_column-reverse) .bh-line-elements bazis-button { display: block; } }`,
);

@Component({
    selector: 'bazis-toolbar',
    template: `
        <div part="start">
            <slot name="start"></slot>
        </div>
        <div part="end">
            <slot name="end"></slot>
        </div>
    `,
    // styleUrls: ['toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false,
})
export class ToolbarElement implements OnInit {
    public el = inject(ElementRef);

    readonly direction = input<'horizontal' | 'vertical'>('horizontal');

    readonly outline = input<boolean>();

    readonly align = input<'top' | 'bottom' | 'center' | 'baseline'>('center');

    readonly adaptiveMode = input<'nowrap' | 'wrap' | 'column' | 'column-reverse'>('nowrap');

    @HostBinding('class') get toolbarStyle() {
        return {
            'bazis-toolbar_outline': this.outline(),
            'bazis-toolbar_vertical': this.direction() === 'vertical',
            [`bazis-toolbar_${this.align()}`]: !!this.align(),
            [`bazis-toolbar_${this.adaptiveMode()}`]: !!this.adaptiveMode(),
        };
    }

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }

        // this.outline = this.outline !== undefined && this.outline !== false;
    }
}
